import { useState } from 'react'
import { autoUpdate } from '@floating-ui/react-dom'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import type { TextDirection } from 'lib/dom/logicalScroll'

export function getCentreFromInlineEnd(container: DOMRect, target: DOMRect, textDirection: TextDirection): number {
  const targetCentre = target.left + target.width / 2
  return textDirection === 'rtl' ? targetCentre - container.left : container.right - targetCentre
}

/** In px, from the container's inline-end edge. */
export function useMicrophoneCentreOffset(
  containerElement: HTMLElement | null,
  microphoneElement: HTMLElement | null,
  textDirection: TextDirection,
) {
  const [offset, setOffset] = useState(0)

  // autoUpdate also catches the mic moving without either element resizing (composer stacking, padding transitions).
  useIsomorphicLayoutEffect(() => {
    if (!containerElement || !microphoneElement) return

    return autoUpdate(microphoneElement, containerElement, () => {
      setOffset(getCentreFromInlineEnd(
        containerElement.getBoundingClientRect(),
        microphoneElement.getBoundingClientRect(),
        textDirection,
      ))
    })
  }, [containerElement, microphoneElement, textDirection])

  return offset
}
